import React from 'react';

import { Steps } from 'antd';
import { SettingOutlined, ClockCircleOutlined } from '@ant-design/icons';

const { Step } = Steps;

const DownloadFolderStep = (props) => {
  const { current, deliveryMethod, onChange } = props;

  return (
    <Steps
      current={current}
      labelPlacement='vertical'
      size='small'
      onChange={onChange}
    >
      <Step title='Download Settings' icon={<SettingOutlined />} />
      <Step
        title='Schedule Settings'
        icon={<ClockCircleOutlined />}
        disabled={deliveryMethod === 'direct'}
      />
    </Steps>
  );
};

export default DownloadFolderStep;
